<template>
    <div></div>
</template>

<script>
import {Calendar} from '@fullcalendar/core'
import { bus } from '@/main'
import moment from 'moment'
export default {
  props: {
    events: Array,
    options: null,
    resources: Array,
    refetch: Boolean,
    chosenDate: Date
  },
  calendar: null,
  draggable: null,
  watch: {
    events (value) {
      this.calendar.removeAllEventSources()
      this.calendar.addEventSource(value)
    },
    chosenDate (value) {
      if (value !== undefined && value !== null && this.calendar) {
        this.calendar.gotoDate(value)
      }
    },
    options (value) {
      if (value && this.calendar) {
        for (let prop in value) {
          this.calendar.setOption(prop, value[prop])
        }
      }
    },
    resources (value) {
      this.calendar.refetchResources()
    },
    refetch (value) {
      this.calendar.removeAllEventSources()
      this.calendar.refetchResources()
      this.calendar.addEventSource(this.events)
    }
  },
  mounted () {
    if (this.$el.offsetParent) {
      this.initialize()
    }
  },
  updated () {
    if (!this.calendar && this.$el.offsetParent) {
      this.initialize()
    }
  },
  beforeDestroy () {
    if (this.calendar) {
      this.calendar.destroy()
      this.calendar = null
    }
  },
  methods: {
    initialize () {
      let defaultConfig = {theme: false}
      let btnOptions = {
        customButtons: {
          myCustomButton: {
            text: 'Uppdatera',
            click: () => {
              this.$store.dispatch('GET_ORDERS_AS_RESOURCES')
              this.$store.dispatch('GET_CALENDAR_EVENTS')
              this.$store.dispatch('GET_DATE_RANGED_ORDERS')
            }
          },
          goToDateButton: {
            text: 'Gå till datum',
            click: () => {
              bus.$emit('displayGoToDate', true)
            }
          },
          backButton: {
            icon: 'fc-icon-chevron-left',
            click: () => {
              this.calendar.incrementDate({ days: -1 })
            }
          },
          todayButton: {
            text: 'Idag',
            click: () => {
              this.calendar.gotoDate(moment().add(-1, 'days').format('YYYY-MM-DD HH:MM'))
            }
          }
        },
        header: {
          left: 'title',
          center: '',
          right: 'backButton,next, todayButton, goToDateButton, myCustomButton'
        }
      }
      let config = this.options ? {...this.options, ...btnOptions, ...defaultConfig} : defaultConfig
      this.calendar = new Calendar(this.$el, config)
      this.calendar.render()

      if (this.events) {
        this.calendar.removeAllEventSources()
        this.calendar.addEventSource(this.events)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Planning/PlanningCalendar.vue